export default __webpack_public_path__ + "static/media/Category_HardwareandTools_135x195.9749b147.jpg";